import { unitType } from "store/reducers/types";
import { defaultCurrencyFormatter } from "./currency-formatter";
import { defaultNumberFormatter } from "./number-formatter";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

export const getDefaultFormatter = (unit) => {
  if (unit === unitType.MONEY) {
    return defaultCurrencyFormatter;
  } else if (unit === unitType.NUMBER) {
    return defaultNumberFormatter;
  } else {
    return defaultNumberFormatter;
  }
};

export const getAllMonthsBetweenDates = (startDate, endDate) => {
  let start = moment(startDate);
  let end = moment(endDate);
  let months = [];

  while (start <= end) {
    // Get month number (Jan-Dec)
    months.push(`${start.format("MMM")} ${start.format("YY")}`);
    // Move to the next month
    start.add(1, "months");
  }

  return months;
};

export const getAllYearsBetweenDates = (startDate, endDate) => {
  let start = moment(startDate);
  let end = moment(endDate);
  let months = [];

  while (start <= end) {
    // Get month number (Jan-Dec)
    months.push({
      key: uuidv4(),
      title: `${start.format("YYYY")}`,
    });
    // Move to the next month
    start.add(1, "years");
  }

  return months;
};

export const getYearsTitles = (startingYear, totalYear) => {
  const years = [];
  let yearCount = startingYear;
  let loopCount = 1;
  while (loopCount <= totalYear) {
    years?.push({
      key: uuidv4(),
      title: `Year ${yearCount}`,
    });
    yearCount++;
    loopCount++;
  }

  return years;
};
